import { MAX_ONBOARDING_EXPOSURES, type OnboardingHoldoutState } from './constants';

export function parseState(raw: string | null): OnboardingHoldoutState | null {
	if (raw === null) {
		return null;
	}

	const parsed = JSON.parse(raw) as Record<string, unknown>;

	if (typeof parsed.lastSeenAt === 'number' && typeof parsed.exposureCount === 'number') {
		return {
			lastSeenAt: parsed.lastSeenAt,
			exposureCount: Math.min(
				Math.max(0, Math.floor(parsed.exposureCount)),
				MAX_ONBOARDING_EXPOSURES,
			),
			onboardingCompleted: parsed.onboardingCompleted === true,
		};
	}

	return null;
}
